import { CircleAlertIcon } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

type Props = {
  message: string;
  title?: string;
};
export const ErrorAlert = ({ message, title = 'Error' }: Props) => {
  return (
    <div className={'p-4'}>
      <Alert variant="destructive" className={'border-destructive/30 bg-destructive/10'}>
        <CircleAlertIcon className="h-4 w-4" />
        <AlertTitle>{title}</AlertTitle>
        <AlertDescription>{message}</AlertDescription>
      </Alert>
    </div>
  );
};
